import { render, staticRenderFns } from "./ForestPlots.vue?vue&type=template&id=50f93b24&"
import script from "./ForestPlots.vue?vue&type=script&lang=js&"
export * from "./ForestPlots.vue?vue&type=script&lang=js&"
import style0 from "./ForestPlots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports